import { gateway } from "../../../../../../../../../gateway"
import { ICreateFlownectCompany } from "../../../../../../../interfaces/ICompany.interface"

export const createCompanyAction = async (values: ICreateFlownectCompany) => {
    const res = await gateway.post("/companies/flownect", values);

    return res?.data?.data || res?.data;
}